<template>
    <div class="page-scan-in-list">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">快遞記錄</div>
            <div class="breadcrumb-item">門店記錄 差異盤點</div>
        </div>
        
        <div class="left">
        <div class="card-block pd-bt">
            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <span class="subject-label">{{form_data.order || '---'}}</span>
                </FormItem>
            </Form>
        </div>
        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isLoading">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>
            <span class="title-label">物流進度</span>

            <Steps :current="form_data.status + 1 || 0">
                <Step title="珠海倉入庫"></Step>
                <Step title="珠海倉出庫"></Step>
                <Step title="澳門倉入庫"></Step>
                <Step title="澳門倉出庫"></Step>
                <Step title="門店上架"></Step>
                <Step title="用戶簽收"></Step>
            </Steps>

            <br>

            <el-descriptions title="珠海倉信息" :column="2" border>

              <el-descriptions-item label="快遞單號" label-class-name="my-label" content-class-name="my-content" :contentStyle="{'text-align': 'left'}">{{form_data.order || '---'}}</el-descriptions-item>
              <el-descriptions-item label="客戶名稱" :contentStyle="{'text-align': 'left'}">{{form_data.username || '---'}}</el-descriptions-item>

              <el-descriptions-item label="客戶電話" :contentStyle="{'text-align': 'left'}">{{form_data.phone || '---'}}</el-descriptions-item>
              <el-descriptions-item label="會員號" :contentStyle="{'text-align': 'left'}">{{form_data.admininfo == null ? '---' : form_data.admininfo.user_id}}</el-descriptions-item>

              <el-descriptions-item label="重量(kg)" :contentStyle="{'text-align': 'left'}">{{form_data.weight || '---'}}</el-descriptions-item>
              <el-descriptions-item label="泡重(kg)" :contentStyle="{'text-align': 'left'}">{{form_data.order || '---'}}</el-descriptions-item>

              <el-descriptions-item label="尺寸" :contentStyle="{'text-align': 'left'}">{{form_data.long || 0}} X {{form_data.width || 0}} X {{form_data.height || 0}}</el-descriptions-item>
              <el-descriptions-item label="提貨櫃點" :contentStyle="{'text-align': 'left'}">{{form_data.store == null ? '---' : form_data.store.ReceivingName}}</el-descriptions-item>

              <el-descriptions-item label="出庫袋號" :contentStyle="{'text-align': 'left'}">8048451570003</el-descriptions-item>
              <el-descriptions-item label="代收費" :contentStyle="{'text-align': 'left'}">{{form_data.amount || '---'}}</el-descriptions-item>

              <el-descriptions-item label="附加費" :contentStyle="{'text-align': 'left'}">{{form_data.surcharge_price || '---'}}</el-descriptions-item>
              <el-descriptions-item label="到付運費" :contentStyle="{'text-align': 'left'}">{{form_data.freight_collect || '---'}}</el-descriptions-item>

              <el-descriptions-item label="入庫時間" :contentStyle="{'text-align': 'left'}"></el-descriptions-item>
              <el-descriptions-item label="入庫操作人" :contentStyle="{'text-align': 'left'}"></el-descriptions-item>

              <el-descriptions-item label="出庫時間" :contentStyle="{'text-align': 'left'}"></el-descriptions-item>
              <el-descriptions-item label="出庫操作人" :contentStyle="{'text-align': 'left'}"></el-descriptions-item>

              
              <el-descriptions-item label="異常件" :contentStyle="{'text-align': 'left'}"></el-descriptions-item>

              <el-descriptions-item label="備註" :contentStyle="{'text-align': 'left'}"></el-descriptions-item>

            </el-descriptions>

            <br>
            <br>

            <el-descriptions title="澳門倉信息" :column="2" border>

              <el-descriptions-item label="入庫時間" label-class-name="my-label" content-class-name="my-content" :contentStyle="{'text-align': 'left'}"></el-descriptions-item>
              <el-descriptions-item label="入庫操作人" :contentStyle="{'text-align': 'left'}"></el-descriptions-item>

              <el-descriptions-item label="出庫時間" :contentStyle="{'text-align': 'left'}">---</el-descriptions-item>
              <el-descriptions-item label="出庫操作人" :contentStyle="{'text-align': 'left'}">---</el-descriptions-item>

              <el-descriptions-item label="備註" :contentStyle="{'text-align': 'left'}"></el-descriptions-item>

            </el-descriptions>

            <br>
            <br>

            <el-descriptions title="門店信息" :column="2" border>

              <el-descriptions-item label="上架時間" label-class-name="my-label" content-class-name="my-content" :contentStyle="{'text-align': 'left'}">---</EL-descriptions-item>
              <el-descriptions-item label="上架操作人" :contentStyle="{'text-align': 'left'}">---</el-descriptions-item>

              <el-descriptions-item label="簽收時間" :contentStyle="{'text-align': 'left'}">---</el-descriptions-item>
              <el-descriptions-item label="簽收操作人" :contentStyle="{'text-align': 'left'}">---</el-descriptions-item>

              <el-descriptions-item label="門店" :contentStyle="{'text-align': 'left'}">---</el-descriptions-item>
              <el-descriptions-item label="貨架號" :contentStyle="{'text-align': 'left'}">---</el-descriptions-item>

              <el-descriptions-item label="合計費用" :contentStyle="{'text-align': 'left'}">---</el-descriptions-item>
              <el-descriptions-item label="代收費" :contentStyle="{'text-align': 'left'}">---</el-descriptions-item>

              <el-descriptions-item label="超時費" :contentStyle="{'text-align': 'left'}">---</el-descriptions-item>
              <el-descriptions-item label="付款方式" :contentStyle="{'text-align': 'left'}">---</el-descriptions-item>

              <el-descriptions-item label="備註" :contentStyle="{'text-align': 'left'}"></el-descriptions-item>

            </el-descriptions>

            <br>

            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <div class="pg-btn-wrap center">
                        <div class="pg-btn style1">確定</div>
                    </div>
                </FormItem>
            </Form>
        </div>
        </div>

        <div class="right">
        <div class="card-block pd-bt">
            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <span class="subject-label">操作記錄</span>
                </FormItem>
            </Form>
        </div>
        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isLoading">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <!-- <div class="step-wrap" v-if="detail && detail.length">
                <div class="step-item clearfix" v-for="(item, index) in detail" :key="item.id">
                    <div class="left">
                        <div class="l-date">
                            <span>{{item.date}}</span>
                            <span>{{item.week}}</span>
                        </div>
                        <div class="l-time">{{item.time}}</div>
                    </div>
                    <div class="right">
                        <div class="r-address">{{item.describe}} , 操作人：{{item.userinfos}}</div>
                    </div>
                </div>
            </div>

            <div class="data-null" v-else>
                <img src="../../../assets/images/null-data.png" alt="" draggable="false">
                <div>暫無數據</div>
            </div> -->
        </div>  
      </div>
    </div>
</template>

<script>
    import Store from '../../../assets/js/store.js'
    export default {
        data()
        {
            return {
                isShowModalRefund: false,
                isSubmitingRefund:false,
                pickShelves: [],
                pickAddress: [],
                pickAdmin: [],
                pageIndex: 1,
                curPageSize: 10,
                totalCount: 1,
                pageInput: '',
                isLoading: true,
                detail: [],
                isShowModalSign_goods: false,
                isSubmitingLog: false,
                form: {
                    odd_numbers: '',
                    username: '',
                    phone: '',
                    shelves: '',
                    arrive: '',
                    status: '',
                    start_time: '',
                    end_time: '',
                },
                form_data: {},
            };
        },
        created()
        {
            this.pageParam = this.$route.query;
            if(this.pageParam.id == undefined) {
                this.pageParam.id = 0;
            }
            this.getDetail();
        },
        methods: {
            getDetail()
            {
                this.isLoading = true;
                this.$Rq.requestAuth({
                    url: this.$Api.all_search,
                    method: 'get',
                    data: {
                        order: this.pageParam.id
                    }
                }).then((res) =>
                {
                    let resData = res.data.data[0];
                    if(resData == null){
                        resData = '';
                    }

                    let tempArr = [];
                    if (res.code == 0)
                    {
                        this.isLoading = false;
                        this.form_data = resData;
                    }else{
                        this.isLoading = false;
                        this.form_data = resData;
                    }
                });
            },
            handleModalCloseRefund(){
                this.isShowModalRefund = false;
            },
            handleRefund(index)
            {
                this.isShowModalRefund = true;
                let tableData = this.table.data;
                // this.$router.push({path: '/shopSignetodoRemark?id=' + tableData[index].id});
            },
            handleInventory(index){

            },
            handleInventory_Grid(index){
                let tableData = this.table.data;
                this.$router.push({path: '/shopInventoryGrid'});
            },
            getShelvesList(list) //貨架號
            {
                if(list > 0) {
                    this.$Rq.requestAuth({
                        url: this.$Api.shelvesAllList,
                        method: 'get',
                        data:{
                            store_id : list,
                        }
                    }).then((res) =>
                    {
                        if (res.code == 0)
                        {
                            this.pickShelves = res.data;
                        }
                    });
                } else {
                    this.$Rq.requestAuth({
                        url: this.$Api.shelvesAllList,
                        method: 'get',
                        data:{
                            store_id : Store.fetch().store_id,
                        }
                    }).then((res) =>
                    {
                        if (res.code == 0)
                        {
                            this.pickShelves = res.data;
                        }
                    });
                }
            },
            getList()
            {
                let form = this.form;

                this.isLoading = true;
                this.$Rq.requestAuth({
                    url: this.$Api.overtimelist,
                    method: 'get',
                    data: {
                        phone: form.phone,
                        storeId: form.arrive,
                        status: form.status,
                        orderNumber: form.odd_numbers,
                        start_time: form.start_time,
                        end_time: form.end_time,
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                    }
                }).then((res) =>
                {
                    this.isLoading = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data.data;

                        if(resData == undefined)
                        {
                            this.totalCount = 0;
                            this.table.data = tempArr;
                        }
                        else
                        {
                            for (let i = 0; i < resData.length; i++)
                            {
                                tempArr.push({
                                    arriveCode: resData[i].arriveCode,
                                    arrive_time: resData[i].arrive_time,
                                    cainiao_match: resData[i].cainiao_match,
                                    odd_numbers: resData[i].orderNumber,
                                    orderStats: resData[i].orderStats,
                                    outDay: resData[i].outDay + '天',
                                    phone: resData[i].phone,
                                    status: resData[i].status,
                                    stroeName: resData[i].stroeName,
                                });
                            }

                            this.totalCount = res.data.count;
                            this.table.data = tempArr;
                        }
                    }
                }).catch(() =>
                {
                    this.isLoading = false;
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'shopInventoryRecordDetail.scss';
</style>